"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMainPartnerAssetProperty = exports.mainPartnerAssetPropertyDefinition = void 0;
exports.mainPartnerAssetPropertyDefinition = {
    name: 'main-partner-asset',
    type: 'asset',
    constraints: [
        {
            name: 'stencils',
            argument: ['partner-profile'],
        },
    ],
    multiple: false,
    view: { label: 'Main Partner Asset' },
};
const isMainPartnerAssetProperty = (prop) => {
    return prop.name === exports.mainPartnerAssetPropertyDefinition.name;
};
exports.isMainPartnerAssetProperty = isMainPartnerAssetProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFpbi1wYXJ0bmVyLWFzc2V0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvbWFpbi1wYXJ0bmVyLWFzc2V0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFLG9CQUFvQjtJQUMxQixJQUFJLEVBQUUsT0FBTztJQUNiLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsaUJBQWlCLENBQUM7U0FDOUI7S0FDRjtJQUNELFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLG9CQUFvQixFQUFFO0NBQ04sQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QyJ9